import { useMutation } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { buildErrorMessage } from 'utils'
import { UseMutationOptions } from 'react-query/types/react/types'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { sendToApi } from 'api/client'
import { BrandProfile } from 'types'

interface Props {}

export interface Data {
  brand_profile: BrandProfile
}

export interface Variables {
  url: string
  document_media_object_ids?: number[]
  screenshot_media_object_ids?: number[]
  brand_info?: {
    brand_name?: string
    products_and_services?: string
    customers?: string
    customer_location?: string
    additional_text?: string
  }
  brandKitId?: number | null
  language?: string
  timezone?: string
}

export type Options = Omit<UseMutationOptions<Data, unknown, Variables>, 'mutationKey' | 'mutationFn'>

export const createBrandProfile = async ({
  url,
  document_media_object_ids,
  screenshot_media_object_ids,
  brand_info,
  workspaceId,
  brandKitId,
  language,
  timezone,
}: Variables & { workspaceId: number }) => {
  const response = await sendToApi(`/w/${workspaceId}/brand_profiles`, {
    method: 'POST',
    body: {
      url,
      document_media_object_ids,
      screenshot_media_object_ids,
      brand_info,
      brand_kit_id: brandKitId,
      language,
      brand_plan: {
        timezone,
      },
    },
  })

  if (response.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(
      buildErrorMessage(response.data.errors) ||
        'An error occurred! Our team has been notified and we are looking into it.',
    )
  }
  return response.data
}

export const useCreateBrandProfile = (_?: Props, options?: Options) => {
  const workspaceId = useCurrentWorkspaceId()

  return useMutation<Data, Error, Variables>(
    ['createBrandProfile', workspaceId],
    async (variables) => {
      return createBrandProfile({ ...variables, workspaceId })
    },
    options,
  )
}
